import { SegmentsMonthlyVisitsGraphWidget } from "./SegmentsMonthlyVisitsGraphWidget";
import type { DashboardMetric } from "./type";

export class SegmentsTrafficShareGraphWidget extends SegmentsMonthlyVisitsGraphWidget {
    metric: DashboardMetric;

    constructor() {
        super();
        this.metric = "TrafficShare";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsTrafficShareGraph";
    }

    public getGraphData(transformedData) {
        return super.getGraphData(transformedData, this.metric);
    }
}

SegmentsTrafficShareGraphWidget.register();
